import type { RemarkStatus } from '../api/remarksApi';

export const REMARK_STATUS_LABELS: Record<RemarkStatus, string> = {
  new: 'New',
  in_progress: 'In progress',
  fixed: 'Fixed',
  verified: 'Verified',
  rejected: 'Rejected',
};

export const REMARK_CATEGORY_LABELS: Record<string, string> = {
  reply_quality: 'Reply quality',
  grounding: 'Grounding',
  journey: 'Journey',
  tone: 'Tone',
  tooling: 'Tooling',
  knowledge: 'Knowledge',
  other: 'Other',
};

export function remarkStatusLabel(status: string): string {
  return REMARK_STATUS_LABELS[status as RemarkStatus] ?? status.replaceAll('_', ' ');
}

export function remarkCategoryLabel(category: string): string {
  return REMARK_CATEGORY_LABELS[category] ?? category.replaceAll('_', ' ');
}

export function severityClassName(severity: string): string {
  switch (severity) {
    case 'high':
      return 'border-red-500/40 bg-red-500/10 text-red-700 dark:text-red-300';
    case 'medium':
      return 'border-amber-500/40 bg-amber-500/10 text-amber-700 dark:text-amber-300';
    default:
      return 'border-border bg-muted text-muted-foreground';
  }
}

export function remarkDialogPath(remark: {
  dialog_id: string;
  run_id?: string;
  message_id?: string;
}): string {
  const query = new URLSearchParams();
  if (remark.run_id) query.set('run', remark.run_id);
  if (remark.message_id) query.set('message', remark.message_id);
  const suffix = query.size > 0 ? `?${query.toString()}` : '';
  return `/playground/${encodeURIComponent(remark.dialog_id)}${suffix}`;
}
